import { Navigate, useLocation } from 'react-router-dom';

/**
 * Wraps every route while the Coming Soon gate is active. Access is granted
 * when the visitor previously entered the bypass code (session flag set by
 * the ComingSoon page).
 *
 * Special case: invited artists arrive at /artist-setup?token=... from the
 * setup email — that email itself IS the credential, so we let the URL grant
 * access implicitly. The ArtistSetup page then validates the token against
 * the backend, so an invalid token still can't do anything useful.
 */
export function GateGuard({ children }) {
  const location = useLocation();
  let hasAccess = sessionStorage.getItem('t4t_access') === 'true';
  if (!hasAccess && location.pathname === '/artist-setup') {
    const token = new URLSearchParams(location.search).get('token');
    if (token) {
      sessionStorage.setItem('t4t_access', 'true');
      hasAccess = true;
    }
  }
  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }
  return children;
}
